var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGamificationPhone(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 65,
    viewBox: "0 0 81 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M79.8542 22.1214C78.0789 22.8833 64.46 17.7485 62.1091 13.7437C64.544 10.5668 57.8071 10.1097 42.8587 9.83034C27.9101 10.1097 21.1733 10.5668 23.6082 13.7437C21.1936 17.3701 7.63837 22.8833 5.86309 22.1214C4.98436 19.6302 5.51669 16.6438 6.1993 14.3709C6.55588 13.1799 7.29961 12.1438 8.31333 11.4201C15.3508 6.38934 28.0095 0.827871 42.8587 0.827871C57.7078 0.827871 70.3665 6.38934 77.404 11.4201C78.4151 12.1438 79.1589 13.1799 79.5155 14.3709C80.1981 16.6438 80.7304 19.6277 79.8517 22.1214H79.8542Z",
    fill: "#CD0D09"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M69.8876 20.5139C64.4752 18.5382 60.8406 15.5162 61.5181 14.4598C61.7652 14.0764 62.1039 13.4542 62.4682 13.1698C62.0581 13.8935 62.6898 14.3963 63.6296 15.2445C64.9821 16.4635 67.389 17.8856 70.4378 19.0182C73.4968 20.1153 76.2552 20.58 78.0789 20.519C79.3473 20.4784 80.1547 20.4987 80.3101 19.681C80.4043 20.1305 80.2617 20.8238 80.2006 21.2758C80.035 22.5201 75.3001 22.4897 69.8876 20.5139Z",
    fill: "url(#paint0_radial_51_493)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M80.3101 23.2083C79.7218 24.1708 75.3281 24.1556 69.5668 22.0503C69.4954 22.0249 69.4267 21.997 69.3554 21.9716C69.284 21.9462 69.2127 21.9234 69.1414 21.8954C63.38 19.7953 60.0129 16.9764 60.1861 15.8642C60.2701 15.3105 60.6394 15.0566 60.9858 14.8458C61.1259 14.762 61.2813 14.6909 61.4468 14.635C61.2176 15.8184 64.7631 18.6144 69.8851 20.5139C75.0301 22.3627 79.546 22.51 80.1369 21.4561C80.2286 21.6034 80.3025 21.7583 80.3534 21.9132C80.4833 22.2967 80.6005 22.7284 80.3076 23.2058L80.3101 23.2083Z",
    fill: "url(#paint1_radial_51_493)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M80.2005 23.3379C79.5816 24.2013 79.2861 25.8748 78.1348 26.4817C76.1151 27.5432 72.1417 26.8398 68.1072 25.3669C64.0727 23.894 60.5807 21.8751 59.7275 19.7648C59.241 18.5611 60.0993 17.0907 60.1834 16.0343C60.3311 17.2431 63.6448 19.8969 69.1387 21.898C69.2101 21.9234 69.2814 21.9488 69.3527 21.9742C69.424 22.0021 69.4928 22.0275 69.5641 22.0529C75.0555 24.0591 79.3039 24.1683 80.2005 23.3379Z",
    fill: "url(#paint2_radial_51_493)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M60.186 16.0318C60.186 16.0318 60.1911 16.0521 60.2013 16.0952C60.209 16.1384 60.2293 16.1968 60.2599 16.2705C60.3236 16.4203 60.4484 16.626 60.642 16.8571C60.8355 17.0907 61.0979 17.3523 61.4188 17.6266C61.7397 17.9008 62.1243 18.1878 62.5522 18.4849C62.9801 18.7795 63.459 19.0817 63.9786 19.3763C64.4982 19.6734 65.056 19.9629 65.6418 20.2524C66.2276 20.5393 66.8414 20.8136 67.4731 21.0803C68.1047 21.3469 68.7491 21.5958 69.4114 21.8294C70.0609 22.0732 70.7205 22.2992 71.3726 22.5024C72.0272 22.703 72.6741 22.8909 73.3083 23.0484C73.9425 23.2033 74.5564 23.3429 75.1447 23.4496C75.7331 23.5563 76.2934 23.635 76.813 23.6858C77.3326 23.734 77.8089 23.7619 78.2343 23.7594C78.6571 23.7569 79.0264 23.7264 79.3244 23.6731C79.6224 23.6197 79.8516 23.5436 79.9968 23.4699C80.0681 23.4293 80.1242 23.3988 80.1547 23.3709C80.1878 23.3455 80.2057 23.3328 80.2057 23.3328C80.2057 23.3328 80.1904 23.348 80.1573 23.3734C80.1267 23.4039 80.0732 23.4369 80.0045 23.4826C79.8618 23.5664 79.6377 23.6604 79.3346 23.7289C78.7335 23.8635 77.8497 23.9296 76.7977 23.8534C75.7484 23.7823 74.5283 23.6045 73.2446 23.3048C72.6053 23.155 71.9457 22.9823 71.286 22.7792C70.6263 22.576 69.9615 22.3551 69.3018 22.1087C68.6473 21.8751 67.9901 21.6161 67.3559 21.3469C66.7217 21.0777 66.1053 20.7857 65.5195 20.4886C64.3453 19.8943 63.3011 19.2442 62.4503 18.622C61.5996 18.0024 60.9654 17.3853 60.5936 16.8926C60.4051 16.6489 60.2956 16.4305 60.2421 16.2756C60.2191 16.1968 60.1988 16.1359 60.1962 16.0952C60.1911 16.0546 60.186 16.0318 60.186 16.0318Z",
    fill: "url(#paint3_radial_51_493)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M62.4731 13.1698C62.4731 13.1698 62.4655 13.1875 62.4476 13.2231C62.4298 13.2586 62.4043 13.312 62.3865 13.3856C62.3738 13.4212 62.3687 13.4618 62.3636 13.5101C62.3534 13.5558 62.361 13.6066 62.3636 13.6599C62.3789 13.7665 62.412 13.8884 62.4833 14.0078C62.6234 14.2516 62.8704 14.4954 63.1659 14.7569C63.3162 14.8865 63.4741 15.0236 63.6422 15.1709C63.8128 15.3105 63.9962 15.4578 64.1822 15.6127C64.3757 15.7626 64.5846 15.9022 64.7934 16.0572C65.0074 16.207 65.2417 16.3467 65.4735 16.499C65.9498 16.7885 66.4592 17.0806 66.9992 17.3625C67.1342 17.4336 67.2666 17.5072 67.4067 17.5758C67.5468 17.6418 67.6869 17.7104 67.8269 17.7764C67.967 17.845 68.1097 17.911 68.2523 17.9795C68.3949 18.0481 68.5427 18.1065 68.6878 18.1725C68.8356 18.236 68.9808 18.2995 69.1285 18.363C69.2762 18.429 69.4239 18.49 69.5742 18.5484C69.8748 18.6652 70.1779 18.782 70.481 18.8988C70.7891 19.003 71.0948 19.1096 71.4004 19.2137C71.5532 19.2696 71.7086 19.3153 71.8614 19.361C72.0143 19.4067 72.1671 19.4524 72.3199 19.4982C72.4727 19.5439 72.623 19.5921 72.7758 19.6327C72.9286 19.6734 73.0815 19.7115 73.2343 19.7496C73.3871 19.7877 73.5374 19.8283 73.6851 19.8664C73.8354 19.9045 73.9857 19.9324 74.1334 19.9654C74.4314 20.0289 74.7218 20.0975 75.0121 20.1432C75.1573 20.1686 75.2974 20.194 75.44 20.2194C75.5801 20.2448 75.7202 20.2702 75.8577 20.2854C76.1328 20.3184 76.4028 20.3641 76.6626 20.387C76.9249 20.4048 77.1771 20.4327 77.4191 20.4428C77.661 20.4454 77.8953 20.4505 78.1169 20.453C78.3385 20.4505 78.5499 20.4479 78.7486 20.4454C79.1434 20.4352 79.4898 20.4098 79.7547 20.3133C79.8871 20.2676 79.9916 20.1965 80.0705 20.1229C80.1062 20.0822 80.1444 20.0492 80.1673 20.0086C80.1928 19.9705 80.2157 19.9349 80.231 19.8994C80.2641 19.8308 80.2794 19.775 80.2895 19.7369C80.2997 19.6988 80.3074 19.6785 80.3074 19.6785C80.3074 19.6785 80.3023 19.6988 80.2946 19.7369C80.287 19.775 80.2743 19.8334 80.2437 19.9045C80.2335 19.9426 80.2106 19.9781 80.1877 20.0188C80.1673 20.0619 80.1316 20.1 80.096 20.1432C80.017 20.2244 79.91 20.3057 79.7751 20.3565C79.5051 20.4682 79.1536 20.5089 78.7562 20.5368C78.5576 20.5495 78.3462 20.5597 78.1246 20.5724C77.9004 20.58 77.6661 20.5774 77.4191 20.5825C77.172 20.5774 76.9173 20.5597 76.6524 20.547C76.3875 20.5317 76.1175 20.4936 75.8374 20.4682C75.2796 20.3997 74.6912 20.3108 74.0926 20.1787C73.9424 20.1457 73.7895 20.1178 73.6393 20.0822C73.489 20.0441 73.3362 20.0061 73.1833 19.968C73.0305 19.9299 72.8752 19.8918 72.7223 19.8537C72.567 19.8156 72.4141 19.7648 72.2588 19.7216C72.1034 19.6759 71.948 19.6302 71.7927 19.587C71.6348 19.5439 71.4794 19.4956 71.3266 19.4423C71.0184 19.3382 70.7076 19.2366 70.3969 19.1325C70.0938 19.0106 69.7882 18.8912 69.4851 18.7693C69.3322 18.7109 69.1845 18.6474 69.0368 18.5789C68.8891 18.5128 68.7413 18.4468 68.5936 18.3833C68.4459 18.3173 68.2981 18.2563 68.1555 18.1852C68.0129 18.1141 67.8703 18.0456 67.7276 17.9745C67.585 17.9059 67.4449 17.8348 67.3048 17.7662C67.1647 17.6951 67.0323 17.6189 66.8973 17.5478C66.3522 17.2634 65.8479 16.9511 65.3767 16.6463C65.1449 16.4863 64.9132 16.3416 64.7017 16.1816C64.4903 16.0191 64.2815 15.8692 64.093 15.7143C63.9071 15.5543 63.7313 15.407 63.5632 15.2547C63.4002 15.1023 63.2474 14.9576 63.1022 14.8204C62.8169 14.5436 62.575 14.2846 62.44 14.0256C62.3712 13.8986 62.3432 13.7665 62.333 13.6548C62.333 13.5989 62.333 13.5456 62.3432 13.4999C62.3508 13.4516 62.3585 13.411 62.3738 13.3755C62.3967 13.3018 62.4247 13.251 62.4451 13.2155C62.4629 13.1799 62.4731 13.1621 62.4731 13.1621V13.1698Z",
    fill: "url(#paint4_radial_51_493)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M56.2816 3.02453C56.2765 4.0454 50.3292 4.84787 42.9937 4.81994C35.6583 4.78947 29.7186 3.9362 29.7212 2.91787C29.7263 1.89699 35.6736 1.09198 43.009 1.12245C50.3419 1.15293 56.2841 2.00365 56.2816 3.02453Z",
    fill: "url(#paint5_radial_51_493)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M57.1347 8.26602C57.1347 8.80693 50.8028 9.21833 42.9961 9.18785C35.1895 9.15484 28.8627 8.69265 28.8652 8.15174C28.8652 7.61083 35.1971 7.19944 43.0038 7.22991C50.8104 7.26292 57.1372 7.72511 57.1347 8.26602Z",
    fill: "url(#paint6_radial_51_493)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M79.5178 17.5961C78.3971 19.9324 74.1334 20.227 69.997 18.2538C65.8581 16.2806 63.4129 12.7863 64.5336 10.4525C65.6543 8.11619 69.9181 7.82161 74.0544 9.79479C78.1933 11.768 80.6385 15.2623 79.5203 17.5961H79.5178Z",
    fill: "url(#paint7_radial_51_493)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M76.1024 16.6412C75.7229 17.6189 74.1871 17.9389 72.6741 17.3548C71.1587 16.7707 70.2392 15.5035 70.6187 14.5258C70.9982 13.5481 72.5341 13.2282 74.047 13.8123C75.5625 14.3963 76.4819 15.6635 76.1024 16.6412Z",
    fill: "url(#paint8_radial_51_493)"
  }), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15.827 20.5139C21.2394 18.5382 24.8766 15.5162 24.1965 14.4598C23.9494 14.0764 23.6107 13.4542 23.2465 13.1698C23.6565 13.8935 23.0249 14.3963 22.085 15.2445C20.7325 16.4635 18.3256 17.8856 15.2768 19.0182C12.2178 20.1153 9.45941 20.58 7.63574 20.519C6.36732 20.4784 5.55991 20.4987 5.40454 19.681C5.3103 20.1305 5.45548 20.8238 5.51406 21.2758C5.67962 22.5201 10.4145 22.4897 15.827 20.5139Z",
    fill: "url(#paint9_radial_51_493)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M5.40718 23.2083C5.99555 24.1708 10.3917 24.1556 16.1531 22.0503C16.2244 22.0249 16.2932 21.997 16.3645 21.9716C16.4358 21.9462 16.5071 21.9234 16.5784 21.8954C22.3398 19.7953 25.707 16.9764 25.5338 15.8642C25.4497 15.3105 25.0804 15.0566 24.7315 14.8458C24.5914 14.762 24.436 14.6909 24.2679 14.635C24.4997 15.8184 20.9542 18.6144 15.8296 20.5139C10.6872 22.3627 6.16875 22.51 5.57784 21.4561C5.48614 21.6034 5.41483 21.7583 5.36134 21.9132C5.23144 22.2967 5.11428 22.7284 5.40718 23.2058V23.2083Z",
    fill: "url(#paint10_radial_51_493)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M5.51427 23.3379C6.13319 24.2013 6.42865 25.8748 7.5799 26.4817C9.5997 27.5432 13.5731 26.8398 17.6076 25.3669C21.642 23.894 25.1315 21.8751 25.9873 19.7648C26.4738 18.5611 25.6154 17.0907 25.5288 16.0343C25.3811 17.2431 22.0674 19.8969 16.5735 21.898C16.5021 21.9234 16.4308 21.9488 16.3595 21.9742C16.2882 22.0021 16.2194 22.0275 16.1481 22.0529C10.6567 24.0591 6.40827 24.1683 5.51172 23.3379H5.51427Z",
    fill: "url(#paint11_radial_51_493)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5314 16.0318C25.5314 16.0318 25.5288 16.0521 25.5212 16.0952C25.5186 16.1384 25.4982 16.1968 25.4753 16.2756C25.4193 16.4305 25.3098 16.6489 25.1238 16.8926C24.7545 17.3828 24.1178 18.0024 23.267 18.622C22.4189 19.2442 21.3721 19.8943 20.1979 20.4886C19.6121 20.7857 18.9982 21.0777 18.3615 21.3469C17.7273 21.6161 17.0701 21.8751 16.4155 22.1087C15.7559 22.3551 15.0936 22.576 14.4314 22.7792C13.7717 22.9823 13.1146 23.155 12.4727 23.3048C11.1916 23.607 9.97156 23.7823 8.91964 23.8534C7.86772 23.9296 6.9839 23.8635 6.3828 23.7289C6.08225 23.6629 5.85557 23.5664 5.71293 23.4826C5.64416 23.4369 5.59068 23.4039 5.56011 23.3734C5.527 23.3455 5.51172 23.3328 5.51172 23.3328C5.51172 23.3328 5.52955 23.3455 5.56266 23.3709C5.59577 23.3988 5.64926 23.4293 5.72057 23.4699C5.86576 23.5436 6.09499 23.6197 6.39299 23.6731C6.69099 23.7264 7.06031 23.7569 7.48312 23.7594C7.90592 23.7619 8.38477 23.734 8.90436 23.6858C9.42395 23.635 9.9843 23.5563 10.5701 23.4496C11.1585 23.3429 11.7723 23.2033 12.4065 23.0484C13.0407 22.8909 13.6877 22.703 14.3423 22.5024C14.9943 22.2992 15.654 22.0732 16.3035 21.8294C16.9657 21.5958 17.6101 21.3444 18.2418 21.0803C18.8734 20.8136 19.4873 20.5393 20.0731 20.2524C20.6563 19.9629 21.2167 19.6734 21.7363 19.3763C22.2559 19.0791 22.7347 18.7795 23.1626 18.4849C23.5905 18.1878 23.9726 17.9008 24.2935 17.6266C24.6144 17.3523 24.8768 17.0907 25.0703 16.8571C25.2639 16.6235 25.3887 16.4203 25.4524 16.2705C25.4804 16.1943 25.5033 16.1359 25.5084 16.0952C25.5186 16.0546 25.5237 16.0318 25.5237 16.0318H25.5314Z",
    fill: "url(#paint12_radial_51_493)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2441 13.1698C23.2441 13.1698 23.2542 13.1875 23.2721 13.2231C23.2899 13.2586 23.3205 13.3094 23.3408 13.3831C23.3561 13.4186 23.3638 13.4618 23.3714 13.5075C23.3841 13.5532 23.3816 13.6066 23.3816 13.6624C23.374 13.7742 23.3459 13.9037 23.2772 14.0332C23.1422 14.2922 22.9002 14.5512 22.6149 14.828C22.4698 14.9652 22.3169 15.1099 22.1539 15.2623C21.9858 15.4147 21.8075 15.562 21.6241 15.7219C21.4331 15.8769 21.2268 16.0267 21.0154 16.1892C20.8015 16.3492 20.5722 16.4939 20.3404 16.6539C19.8692 16.9587 19.3624 17.271 18.8199 17.5555C18.6849 17.6266 18.5499 17.7053 18.4123 17.7738C18.2723 17.8424 18.1322 17.911 17.9895 17.9821C17.8469 18.0507 17.7043 18.1218 17.5616 18.1929C17.419 18.264 17.2713 18.3249 17.1236 18.3909C16.9758 18.457 16.8281 18.5205 16.6804 18.5865C16.5326 18.6525 16.3824 18.7185 16.2321 18.7769C15.929 18.8963 15.6259 19.0182 15.3203 19.1401C15.0095 19.2442 14.6988 19.3458 14.3906 19.4499C14.2378 19.5032 14.0824 19.5489 13.9245 19.5947C13.7691 19.6404 13.6137 19.6861 13.4584 19.7293C13.303 19.7724 13.1502 19.8232 12.9948 19.8613C12.8395 19.8994 12.6866 19.9375 12.5313 19.9756C12.3784 20.0137 12.2256 20.0518 12.0753 20.0899C11.9225 20.1254 11.7722 20.1533 11.622 20.1864C11.0234 20.3209 10.4351 20.4073 9.87726 20.4759C9.59709 20.5038 9.32455 20.5393 9.06221 20.5546C8.79732 20.5673 8.54262 20.5851 8.29556 20.5901C8.04849 20.5876 7.81417 20.5876 7.59003 20.58C7.36589 20.5673 7.15703 20.5546 6.95837 20.5444C6.56103 20.5165 6.20954 20.4759 5.93956 20.3641C5.80456 20.3108 5.69759 20.2295 5.61863 20.1508C5.58297 20.1076 5.54731 20.0695 5.52694 20.0264C5.50147 19.9857 5.48109 19.9476 5.4709 19.9121C5.44034 19.841 5.4276 19.7826 5.41996 19.7445C5.41232 19.7064 5.40723 19.6861 5.40723 19.6861C5.40723 19.6861 5.41232 19.7064 5.42506 19.7445C5.43524 19.7826 5.45053 19.8384 5.48364 19.907C5.49637 19.9426 5.5193 19.9781 5.54731 20.0162C5.57024 20.0568 5.60844 20.0924 5.6441 20.1305C5.72561 20.2016 5.82749 20.2752 5.95993 20.3209C6.22482 20.4174 6.57122 20.4428 6.96601 20.453C7.16467 20.4555 7.37608 20.4581 7.59767 20.4606C7.81926 20.4581 8.05104 20.453 8.29556 20.4505C8.53752 20.4403 8.79222 20.4149 9.05202 20.3946C9.31182 20.3717 9.5818 20.3286 9.85688 20.293C9.99442 20.2778 10.1345 20.2524 10.2746 20.227C10.4147 20.2016 10.5573 20.1762 10.7025 20.1508C10.9903 20.1026 11.2832 20.034 11.5787 19.973C11.7264 19.94 11.8767 19.9121 12.0269 19.874C12.1772 19.8359 12.3275 19.7953 12.4778 19.7572C12.6306 19.7191 12.7809 19.6785 12.9362 19.6404C13.0891 19.6023 13.2393 19.5515 13.3947 19.5058C13.5475 19.4601 13.7003 19.4144 13.8532 19.3686C14.006 19.3229 14.1614 19.2772 14.3142 19.2214C14.6198 19.1172 14.928 19.0106 15.2337 18.9065C15.5368 18.7896 15.8398 18.6728 16.1404 18.556C16.2932 18.5001 16.4409 18.4367 16.5887 18.3706C16.7364 18.3071 16.8841 18.2437 17.0293 18.1802C17.1745 18.1141 17.3222 18.0557 17.4649 17.9872C17.6075 17.9186 17.7501 17.85 17.8902 17.784C18.0303 17.7154 18.1704 17.6494 18.3105 17.5834C18.448 17.5148 18.583 17.4412 18.718 17.3701C19.258 17.0907 19.7674 16.7987 20.2437 16.5066C20.4754 16.3543 20.7098 16.2146 20.9237 16.0648C21.1351 15.9124 21.344 15.7702 21.535 15.6204C21.7235 15.4655 21.9043 15.3182 22.075 15.1785C22.2431 15.0337 22.4035 14.8941 22.5513 14.7646C22.8467 14.503 23.0938 14.2592 23.2339 14.0154C23.3052 13.8935 23.3383 13.7742 23.3536 13.6675C23.3536 13.6142 23.3612 13.5634 23.3536 13.5177C23.3485 13.472 23.3434 13.4288 23.3307 13.3932C23.3128 13.3196 23.2874 13.2663 23.2695 13.2307C23.2542 13.1952 23.2441 13.1774 23.2441 13.1774V13.1698Z",
    fill: "url(#paint13_radial_51_493)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M6.19919 17.5961C7.31988 19.9324 11.5836 20.227 15.72 18.2538C19.8589 16.2806 22.304 12.7863 21.1833 10.4525C20.0627 8.11619 15.7989 7.82161 11.6626 9.79479C7.52364 11.768 5.0785 15.2623 6.19664 17.5961H6.19919Z",
    fill: "url(#paint14_radial_51_493)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M9.61234 16.6412C9.99185 17.6189 11.5277 17.9389 13.0406 17.3548C14.5561 16.7707 15.4756 15.5035 15.0961 14.5258C14.7166 13.5481 13.1807 13.2282 11.6678 13.8123C10.1523 14.3963 9.23284 15.6635 9.61234 16.6412Z",
    fill: "url(#paint15_radial_51_493)"
  }), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M5.44023 19.6251L1.16886 20.9965C1.10009 21.0193 1.02623 21.0091 0.9651 20.9711C0.903972 20.933 0.863219 20.8695 0.853031 20.7984L0.707851 19.7267C0.695116 19.6277 0.75115 19.5337 0.842843 19.4956L5.57777 17.6037L5.44023 19.6251Z",
    fill: "url(#paint16_linear_51_493)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    d: "M33.7885 8.58346C33.7885 9.70845 32.1202 10.6227 30.0622 10.6227C28.0042 10.6227 26.3359 9.71099 26.3359 8.58346C26.3359 7.45592 28.0042 6.54425 30.0622 6.54425C32.1202 6.54425 33.7885 7.45592 33.7885 8.58346Z",
    fill: "url(#paint17_radial_51_493)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    d: "M58.8413 8.66726C58.8413 9.79225 57.173 10.7065 55.115 10.7065C53.057 10.7065 51.3887 9.79479 51.3887 8.66726C51.3887 7.53973 53.057 6.62805 55.115 6.62805C57.173 6.62805 58.8413 7.53973 58.8413 8.66726Z",
    fill: "url(#paint18_radial_51_493)"
  }), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M69.8291 59.9242C69.8291 62.6541 67.6107 64.866 64.8726 64.866H20.8422C18.1066 64.866 15.8882 62.6541 15.8882 59.9242V49.6825H69.8291V59.9242Z",
    fill: "url(#paint19_linear_51_493)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M69.8291 59.9242C69.8291 62.6541 67.6107 64.866 64.8726 64.866H20.8422C18.1066 64.866 15.8882 62.6541 15.8882 59.9242V49.6825H69.8291V59.9242Z",
    fill: "url(#paint20_radial_51_493)"
  }), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M68.7338 52.8467C67.8296 53.9336 66.4847 54.5633 65.0635 54.5633H20.6535C19.2348 54.5633 17.8875 53.9336 16.9833 52.8467C16.0791 51.7572 15.7047 50.3224 15.9695 48.9333L19.8792 28.2518C20.3428 25.8062 22.4874 24.0337 24.9835 24.0337H27.393C29.2905 24.0337 36.2337 22.929 36.2337 16.7581H49.4731C49.4731 22.929 56.4138 24.0337 58.3139 24.0337H60.7234C63.2195 24.0337 65.3666 25.8062 65.8276 28.2518L69.7373 48.9333C70.0022 50.325 69.6303 51.7572 68.7261 52.8467H68.7338Z",
    fill: "#CD0D09"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.6,
    d: "M21.2752 26.4589C21.8356 26.563 21.2676 32.1803 20.0094 39.009C18.7486 45.8351 17.2713 51.2874 16.711 51.1858C16.1506 51.0817 16.7161 45.4618 17.9768 38.6382C19.2376 31.8121 20.7149 26.3598 21.2752 26.4614V26.4589Z",
    fill: "url(#paint21_radial_51_493)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.6,
    d: "M64.4371 26.243C63.724 26.4436 64.0551 32.1803 65.1758 39.0547C66.299 45.9266 67.7865 51.3357 68.4971 51.1376C69.2103 50.937 68.8792 45.1977 67.7559 38.3284C66.6352 31.454 65.1478 26.0449 64.4346 26.2456L64.4371 26.243Z",
    fill: "url(#paint22_radial_51_493)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M59.0882 32.8355C59.0882 40.0045 51.8216 45.8174 42.8586 45.8174C33.8956 45.8174 26.6289 40.0045 26.6289 32.8355C26.6289 25.6666 33.8956 19.8537 42.8586 19.8537C51.8216 19.8537 59.0882 25.6666 59.0882 32.8355Z",
    fill: "url(#paint23_radial_51_493)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.9,
    d: "M66.7088 53.1387C66.7088 53.9259 55.8661 54.5659 42.4891 54.5659C29.1121 54.5659 18.272 53.9259 18.272 53.1387C18.272 52.3515 29.1147 51.7115 42.4891 51.7115C55.8635 51.7115 66.7088 52.3489 66.7088 53.1387Z",
    fill: "url(#paint24_radial_51_493)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.4,
    d: "M42.5555 37.7139C53.9271 37.7139 63.1457 35.7014 63.1457 33.219C63.1457 30.7365 53.9271 28.7241 42.5555 28.7241C31.1839 28.7241 21.9653 30.7365 21.9653 33.219C21.9653 35.7014 31.1839 37.7139 42.5555 37.7139Z",
    fill: "url(#paint25_radial_51_493)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.4,
    d: "M35.3677 37.9399C41.6818 41.1853 45.4259 46.47 43.7321 49.7485C42.0384 53.027 35.546 53.0524 29.2345 49.8094C22.9204 46.564 19.1737 41.2793 20.87 38.0008C22.5638 34.7249 29.0562 34.697 35.3677 37.9399Z",
    fill: "url(#paint26_radial_51_493)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.4,
    d: "M50.3493 37.9399C44.0352 41.1853 40.2911 46.47 41.9849 49.7485C43.6786 53.027 50.171 53.0524 56.4826 49.8094C62.7966 46.564 66.5433 41.2793 64.847 38.0008C63.1532 34.7249 56.6608 34.697 50.3493 37.9399Z",
    fill: "url(#paint27_radial_51_493)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M42.1988 41.1396C28.4652 41.4393 17.6276 44.1743 17.9918 47.2471C18.3561 50.3199 29.7846 52.5699 43.5156 52.2677C57.2517 51.968 68.0893 49.233 67.7251 46.1602C67.3634 43.0874 55.9323 40.8374 42.1988 41.1396Z",
    fill: "url(#paint28_radial_51_493)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_51_493",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 15,
    y: 16,
    width: 55,
    height: 39
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M68.7338 52.8467C67.8296 53.9336 66.4847 54.5633 65.0635 54.5633H20.6535C19.2348 54.5633 17.8875 53.9336 16.9833 52.8467C16.0791 51.7572 15.7047 50.3224 15.9695 48.9333L19.8792 28.2518C20.3428 25.8062 22.4874 24.0337 24.986 24.0337H27.3955C29.293 24.0337 36.2362 22.929 36.2362 16.7581H49.4757C49.4757 22.929 56.4163 24.0337 58.3164 24.0337H60.7259C63.222 24.0337 65.3691 25.8062 65.8302 28.2518L69.7398 48.9333C70.0047 50.325 69.6329 51.7572 68.7287 52.8467H68.7338Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_51_493)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M29.0203 20.4301C32.9987 22.1748 34.4251 27.6626 32.2066 32.6857C29.9881 37.7088 24.9654 40.3676 20.9895 38.6205C17.011 36.8733 15.5847 31.388 17.8032 26.3649C20.0216 21.3418 25.0444 18.683 29.0203 20.4301Z",
    fill: "url(#paint29_radial_51_493)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M56.3267 20.1914C52.3483 21.9361 50.9245 27.4239 53.1404 32.447C55.3589 37.4701 60.3816 40.1289 64.3575 38.3818C68.336 36.6346 69.7598 31.1493 67.5439 26.1262C65.3254 21.1031 60.3027 18.4443 56.3267 20.1914Z",
    fill: "url(#paint30_radial_51_493)"
  }))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M57.3739 9.82018C55.9934 13.4186 54.4091 15.4172 51.1973 16.6057C50.7007 16.7911 50.1581 16.885 49.6156 16.885H36.1062C35.5611 16.885 35.0212 16.7885 34.5219 16.6057C31.3101 15.4172 29.7259 13.4186 28.3454 9.82018C28.2206 9.49259 28.269 9.13452 28.4778 8.83994C28.6893 8.54536 29.0407 8.34474 29.4381 8.29141C29.8456 8.23808 30.3321 8.21777 30.9485 8.21015C31.4273 8.20507 31.873 8.42347 32.1125 8.77646C32.7034 9.64496 33.8928 11.2575 34.876 11.7121C36.72 12.5654 40.8615 12.1565 42.8635 12.1565C44.8654 12.1565 49.0043 12.5679 50.8509 11.7121C51.8315 11.2575 53.021 9.64496 53.6119 8.77646C53.8513 8.42347 54.2996 8.20507 54.7785 8.21015C55.3948 8.21777 55.8788 8.23555 56.2863 8.29141C56.6862 8.34474 57.0351 8.5479 57.2465 8.83994C57.4554 9.13452 57.5038 9.49259 57.379 9.82018H57.3739Z",
    fill: "url(#paint31_radial_51_493)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M50.5839 12.865C50.5839 13.1469 46.9595 13.3755 42.4895 13.3755C38.0194 13.3755 34.395 13.1469 34.395 12.865C34.395 12.5831 38.0194 12.3546 42.4895 12.3546C46.9595 12.3546 50.5839 12.5831 50.5839 12.865Z",
    fill: "url(#paint32_radial_51_493)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M31.8911 8.60123C31.8987 8.82217 31.1881 9.0304 30.3017 9.06596C29.4154 9.10151 28.6894 8.95168 28.6793 8.73074C28.6716 8.50981 29.3822 8.30157 30.2686 8.26602C31.155 8.23047 31.8834 8.3803 31.8911 8.60123Z",
    fill: "url(#paint33_radial_51_493)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M53.923 8.60123C53.9128 8.82217 54.6259 9.0304 55.5123 9.06596C56.3987 9.10151 57.1246 8.95168 57.1348 8.73074C57.1449 8.50981 56.4318 8.30157 55.5454 8.26602C54.6591 8.23047 53.9306 8.3803 53.923 8.60123Z",
    fill: "url(#paint34_radial_51_493)"
  }), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M42.8561 41.9954C50.0617 41.9954 55.9351 36.6321 55.9351 30.0548C55.9351 23.4775 50.0617 18.1192 42.8561 18.1192C35.6506 18.1192 29.7822 23.4851 29.7822 30.0548C29.7822 36.6244 35.6557 41.9954 42.8561 41.9954Z",
    fill: "#400303"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.8561 41.259C50.0617 41.259 55.9351 35.8981 55.9351 29.3209C55.9351 22.7436 50.0617 17.3853 42.8561 17.3853C35.6506 17.3853 29.7822 22.7487 29.7822 29.3209C29.7822 35.8931 35.6557 41.259 42.8561 41.259Z",
    fill: "url(#paint35_linear_51_493)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.8561 40.6368C50.0617 40.6368 55.9351 35.2709 55.9351 28.6936C55.9351 22.1164 50.0617 16.7581 42.8561 16.7581C35.6506 16.7581 29.7822 22.1214 29.7822 28.6936C29.7822 35.2658 35.6557 40.6368 42.8561 40.6368Z",
    fill: "url(#paint36_radial_51_493)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.8561 16.7581C35.6582 16.7581 29.7822 22.1214 29.7822 28.6936C29.7822 35.2658 35.6557 40.6368 42.8561 40.6368C50.0566 40.6368 55.9351 35.2709 55.9351 28.6936C55.9351 22.1164 50.0617 16.7581 42.8561 16.7581ZM42.8561 40.1823C35.8136 40.1823 30.0828 34.9763 30.0828 28.5794C30.0828 22.1824 35.8136 16.979 42.8561 16.979C49.8986 16.979 55.6346 22.1824 55.6346 28.5794C55.6346 34.9763 49.9012 40.1823 42.8561 40.1823Z",
    fill: "url(#paint37_radial_51_493)"
  }), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.4546 18.4138C39.6212 18.4138 40.5636 19.2493 40.5636 20.2829C40.5636 21.3164 39.6186 22.1468 38.4546 22.1468C37.2906 22.1468 36.3457 21.3113 36.3457 20.2829C36.3457 19.2544 37.2906 18.4138 38.4546 18.4138Z",
    fill: "url(#paint38_radial_51_493)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.8407 21.0371C36.0225 21.0371 36.9827 21.8827 36.9827 22.929C36.9827 23.9753 36.0225 24.8235 34.8407 24.8235C33.6589 24.8235 32.7012 23.9753 32.7012 22.929C32.7012 21.8827 33.6614 21.0371 34.8407 21.0371Z",
    fill: "url(#paint39_radial_51_493)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.8464 24.9682C34.0435 24.9682 35.0165 25.8265 35.0165 26.8906C35.0165 27.9546 34.0435 28.8079 32.8464 28.8079C31.6493 28.8079 30.6738 27.947 30.6738 26.8906C30.6738 25.8342 31.6468 24.9682 32.8464 24.9682Z",
    fill: "url(#paint40_radial_51_493)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.1977 29.2853C34.4152 29.2853 35.3983 30.1589 35.3983 31.2382C35.3983 32.3175 34.4152 33.1809 33.1977 33.1809C31.9802 33.1809 30.9971 32.3099 30.9971 31.2382C30.9971 30.1665 31.9828 29.2853 33.1977 29.2853Z",
    fill: "url(#paint41_radial_51_493)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.745 33.0996C36.9777 33.0996 37.9787 33.9808 37.9787 35.0728C37.9787 36.1648 36.9777 37.046 35.745 37.046C34.5122 37.046 33.5112 36.1622 33.5112 35.0728C33.5112 33.9834 34.5097 33.0996 35.745 33.0996Z",
    fill: "url(#paint42_radial_51_493)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.2886 35.276C41.5418 35.276 42.5555 36.1699 42.5555 37.2745C42.5555 38.3792 41.5443 39.2782 40.2886 39.2782C39.0329 39.2782 38.0269 38.3818 38.0269 37.2745C38.0269 36.1673 39.0406 35.276 40.2886 35.276Z",
    fill: "url(#paint43_radial_51_493)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.2578 35.4156C46.5262 35.4156 47.5552 36.3248 47.5552 37.4472C47.5552 38.5697 46.5262 39.4737 45.2578 39.4737C43.9893 39.4737 42.9629 38.5646 42.9629 37.4472C42.9629 36.3299 43.9919 35.4156 45.2578 35.4156Z",
    fill: "url(#paint44_radial_51_493)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.7688 37.4218C51.0525 37.4218 52.0968 36.5 52.0968 35.3623C52.0968 34.2246 51.0525 33.3079 49.7688 33.3079C48.4851 33.3079 47.4434 34.2322 47.4434 35.3623C47.4434 36.4924 48.4876 37.4218 49.7688 37.4218Z",
    fill: "url(#paint45_radial_51_493)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.1361 17.4742C44.2823 17.4742 45.2145 18.297 45.2145 19.3102C45.2145 20.3235 44.2823 21.1463 43.1361 21.1463C41.9899 21.1463 41.0552 20.3235 41.0552 19.3102C41.0552 18.297 41.9874 17.4742 43.1361 17.4742Z",
    fill: "url(#paint46_radial_51_493)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "lighten"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.93 28.8181C55.93 28.8892 55.9351 28.9628 55.9351 29.039C55.9351 35.6315 50.0795 40.9771 42.8561 40.9771C35.6327 40.9771 29.7822 35.6315 29.7822 29.039C29.7822 28.9628 29.7822 28.8892 29.7873 28.8181C29.9147 35.3039 35.7168 40.5327 42.8561 40.5327C49.9954 40.5327 55.8001 35.3039 55.93 28.8181Z",
    fill: "url(#paint47_linear_51_493)"
  }), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.9989 34.9382C46.9901 34.9382 50.2401 32.0051 50.2401 28.4117C50.2401 24.8184 46.9901 21.8903 42.9989 21.8903C39.0077 21.8903 35.7603 24.8209 35.7603 28.4117C35.7603 32.0026 39.0103 34.9382 42.9989 34.9382Z",
    fill: "url(#paint48_radial_51_493)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.9985 34.2906C46.8139 34.2906 49.9213 31.5277 49.9213 28.14C49.9213 24.7523 46.8114 21.9843 42.9985 21.9843C39.1856 21.9843 36.0757 24.7473 36.0757 28.14C36.0757 31.5328 39.1856 34.2906 42.9985 34.2906Z",
    fill: "url(#paint49_radial_51_493)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.9985 33.3079C46.5338 33.3079 49.417 30.8141 49.417 27.7591C49.417 24.7041 46.5338 22.2052 42.9985 22.2052C39.4632 22.2052 36.5825 24.699 36.5825 27.7591C36.5825 30.8192 39.4658 33.3079 42.9985 33.3079Z",
    fill: "url(#paint50_linear_51_493)"
  }), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.9192 27.914C49.9243 27.9902 49.9243 28.0638 49.9243 28.14C49.9243 31.5378 46.8245 34.2906 43.0014 34.2906C39.1783 34.2906 36.0786 31.5353 36.0786 28.14C36.0786 28.0638 36.0837 27.9902 36.0837 27.914C36.2162 31.2052 39.2649 33.8437 43.0014 33.8437C46.7379 33.8437 49.7893 31.2052 49.9217 27.914H49.9192Z",
    fill: "url(#paint51_linear_51_493)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.7207 22.2357C48.8464 22.2357 49.7659 21.4205 49.7659 20.4276C49.7659 19.4347 48.8439 18.6195 47.7207 18.6195C46.5974 18.6195 45.6729 19.4296 45.6729 20.4276C45.6729 21.4256 46.5923 22.2357 47.7207 22.2357Z",
    fill: "url(#paint52_radial_51_493)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.7207 18.617C48.8515 18.617 49.7659 19.4271 49.7659 20.4251C49.7659 20.5343 49.7583 20.646 49.7354 20.7501C49.5622 19.9096 48.7267 19.2671 47.7207 19.2671C46.7146 19.2671 45.8817 19.9096 45.706 20.7501C45.6856 20.646 45.6729 20.5317 45.6729 20.4251C45.6729 19.4245 46.5898 18.617 47.7207 18.617Z",
    fill: "url(#paint53_linear_51_493)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.136 17.4742C44.2822 17.4742 45.2144 18.297 45.2144 19.3102C45.2144 19.422 45.2016 19.5312 45.1838 19.6353C45.0081 18.7744 44.1599 18.1243 43.1385 18.1243C42.1172 18.1243 41.2665 18.7744 41.0933 19.6353C41.0704 19.5312 41.0576 19.422 41.0576 19.3102C41.0576 18.297 41.9898 17.4742 43.1385 17.4742H43.136Z",
    fill: "url(#paint54_linear_51_493)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.4547 18.4138C39.6213 18.4138 40.5637 19.2493 40.5637 20.2829C40.5637 20.3921 40.556 20.5038 40.5306 20.6079C40.3574 19.7343 39.4939 19.069 38.4522 19.069C37.4105 19.069 36.5521 19.7343 36.3764 20.6079C36.356 20.5038 36.3433 20.3921 36.3433 20.2829C36.3433 19.2518 37.2882 18.4138 38.4522 18.4138H38.4547Z",
    fill: "url(#paint55_linear_51_493)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.8406 21.0371C36.0224 21.0371 36.9826 21.8827 36.9826 22.929C36.9826 23.0407 36.9699 23.1499 36.9521 23.2591C36.7763 22.3678 35.9001 21.6923 34.8431 21.6923C33.7861 21.6923 32.9099 22.3678 32.7342 23.2591C32.7138 23.1499 32.7036 23.0407 32.7036 22.929C32.7036 21.8853 33.6638 21.0371 34.8431 21.0371H34.8406Z",
    fill: "url(#paint56_linear_51_493)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.8464 24.9682C34.0435 24.9682 35.0165 25.8265 35.0165 26.8906C35.0165 26.9998 35.0089 27.1115 34.9859 27.2156C34.8127 26.3116 33.9213 25.6234 32.8464 25.6234C31.7716 25.6234 30.8827 26.3116 30.7069 27.2156C30.6866 27.1115 30.6738 26.9973 30.6738 26.8906C30.6738 25.8265 31.6468 24.9682 32.8464 24.9682Z",
    fill: "url(#paint57_linear_51_493)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.1978 29.2853C34.4153 29.2853 35.3984 30.1589 35.3984 31.2382C35.3984 31.3448 35.3908 31.454 35.3704 31.5632C35.1947 30.6465 34.2905 29.9431 33.1978 29.9431C32.1051 29.9431 31.206 30.644 31.0277 31.5632C31.0074 31.454 30.9946 31.3448 30.9946 31.2382C30.9946 30.1589 31.9803 29.2853 33.1953 29.2853H33.1978Z",
    fill: "url(#paint58_linear_51_493)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.7449 33.0996C36.9776 33.0996 37.9786 33.9808 37.9786 35.0728C37.9786 35.1871 37.971 35.2963 37.9506 35.3979C37.7748 34.4659 36.8528 33.7523 35.7449 33.7523C34.6369 33.7523 33.72 34.4684 33.5442 35.3979C33.5239 35.2937 33.5137 35.1845 33.5137 35.0728C33.5137 33.9834 34.5121 33.0996 35.7474 33.0996H35.7449Z",
    fill: "url(#paint59_linear_51_493)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.2885 35.276C41.5416 35.276 42.5554 36.1699 42.5554 37.2745C42.5554 37.3888 42.5426 37.498 42.5248 37.6047C42.3491 36.6549 41.4168 35.9261 40.2911 35.9261C39.1653 35.9261 38.2356 36.6549 38.0573 37.6047C38.0369 37.498 38.0293 37.3888 38.0293 37.2745C38.0293 36.1699 39.043 35.276 40.2911 35.276H40.2885Z",
    fill: "url(#paint60_linear_51_493)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.2578 35.4156C46.5262 35.4156 47.5552 36.3248 47.5552 37.4472C47.5552 37.5564 47.5424 37.6656 47.5221 37.7748C47.3463 36.8124 46.3988 36.0734 45.2578 36.0734C44.1167 36.0734 43.1717 36.8098 42.9909 37.7748C42.9756 37.6656 42.9629 37.5564 42.9629 37.4472C42.9629 36.3248 43.9919 35.4156 45.2578 35.4156Z",
    fill: "url(#paint61_linear_51_493)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.7687 33.3079C51.0549 33.3079 52.0967 34.2272 52.0967 35.3623C52.0967 35.4766 52.0839 35.5858 52.0661 35.6924C51.8853 34.7097 50.925 33.9605 49.7687 33.9605C48.6123 33.9605 47.647 34.7097 47.4713 35.6924C47.456 35.5832 47.4458 35.474 47.4458 35.3623C47.4458 34.2272 48.485 33.3079 49.7712 33.3079H49.7687Z",
    fill: "url(#paint62_linear_51_493)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.7208 18.617C48.8516 18.617 49.766 19.4271 49.766 20.4251V20.5241C49.7049 19.5693 48.8134 18.8125 47.7208 18.8125C46.6281 18.8125 45.7315 19.5693 45.6755 20.5241C45.6704 20.4911 45.6704 20.4555 45.6704 20.4251C45.6704 19.4245 46.5873 18.617 47.7182 18.617H47.7208Z",
    fill: "url(#paint63_linear_51_493)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.1361 17.4742C44.2823 17.4742 45.2145 18.297 45.2145 19.3102C45.2145 19.3407 45.2145 19.3763 45.2094 19.4093C45.1533 18.4392 44.2466 17.6723 43.1361 17.6723C42.0256 17.6723 41.1188 18.4392 41.0603 19.4093C41.0603 19.3763 41.0552 19.3407 41.0552 19.3102C41.0552 18.297 41.9874 17.4742 43.1361 17.4742Z",
    fill: "url(#paint64_linear_51_493)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.4546 18.4138C39.6212 18.4138 40.5636 19.2493 40.5636 20.2829V20.3819C40.5025 19.394 39.583 18.6195 38.4546 18.6195C37.3263 18.6195 36.4094 19.3966 36.3508 20.3819C36.3508 20.3514 36.3457 20.3133 36.3457 20.2829C36.3457 19.2518 37.2906 18.4138 38.4546 18.4138Z",
    fill: "url(#paint65_linear_51_493)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.8407 21.0371C36.0225 21.0371 36.9827 21.8827 36.9827 22.929C36.9827 22.9646 36.9802 22.995 36.9802 23.028C36.919 22.0326 35.9868 21.2377 34.8432 21.2377C33.6996 21.2377 32.7623 22.0351 32.7063 23.028C32.7012 22.995 32.7012 22.9646 32.7012 22.929C32.7012 21.8853 33.6614 21.0371 34.8407 21.0371Z",
    fill: "url(#paint66_linear_51_493)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.8464 24.9682C34.0435 24.9682 35.0165 25.8265 35.0165 26.8906V26.9896C34.9579 25.9764 34.0079 25.1714 32.8464 25.1714C31.685 25.1714 30.7375 25.9764 30.6764 26.9896C30.6764 26.9592 30.6738 26.9211 30.6738 26.8906C30.6738 25.8265 31.6468 24.9682 32.8464 24.9682Z",
    fill: "url(#paint67_linear_51_493)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.1978 29.2853C34.4153 29.2853 35.3984 30.1589 35.3984 31.2382V31.3347C35.3373 30.3062 34.3771 29.4859 33.1978 29.4859C32.0185 29.4859 31.0558 30.3062 30.9997 31.3347C30.9946 31.2991 30.9946 31.2687 30.9946 31.2382C30.9946 30.1589 31.9803 29.2853 33.1953 29.2853H33.1978Z",
    fill: "url(#paint68_linear_51_493)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.745 33.0996C36.9777 33.0996 37.9787 33.9808 37.9787 35.0728C37.9787 35.1058 37.9787 35.1414 37.9736 35.1744C37.9176 34.1281 36.9421 33.3003 35.745 33.3003C34.5479 33.3003 33.5749 34.1281 33.5138 35.1744C33.5138 35.1414 33.5112 35.1058 33.5112 35.0728C33.5112 33.9834 34.5097 33.0996 35.745 33.0996Z",
    fill: "url(#paint69_linear_51_493)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.2886 35.276C41.5418 35.276 42.5555 36.1699 42.5555 37.2745C42.5555 37.3101 42.5555 37.3431 42.5504 37.3736C42.4943 36.3146 41.501 35.474 40.2886 35.474C39.0762 35.474 38.088 36.3146 38.0269 37.3736V37.2745C38.0269 36.1699 39.0406 35.276 40.2886 35.276Z",
    fill: "url(#paint70_linear_51_493)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.2578 35.4156C46.5262 35.4156 47.5552 36.3248 47.5552 37.4472C47.5552 37.4802 47.5526 37.5107 47.5526 37.5488C47.4915 36.4721 46.488 35.6163 45.2578 35.6163C44.0276 35.6163 43.0215 36.4721 42.968 37.5488C42.9629 37.5107 42.9629 37.4802 42.9629 37.4472C42.9629 36.3248 43.9919 35.4156 45.2578 35.4156Z",
    fill: "url(#paint71_linear_51_493)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.7688 33.3079C51.055 33.3079 52.0968 34.2272 52.0968 35.3623C52.0968 35.3979 52.0968 35.4309 52.0917 35.4614C52.0331 34.3719 51.0143 33.506 49.7688 33.506C48.5233 33.506 47.5019 34.3694 47.4485 35.4614C47.4434 35.4309 47.4434 35.3979 47.4434 35.3623C47.4434 34.2272 48.4825 33.3079 49.7688 33.3079Z",
    fill: "url(#paint72_linear_51_493)"
  }), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M48.0622 21.9716H47.5987V20.5622C47.4306 20.6866 47.2293 20.7831 46.9976 20.8466V20.5038C47.1224 20.4733 47.2523 20.4149 47.3923 20.326C47.5375 20.2346 47.6343 20.1305 47.6853 20.0137H48.0622V21.9742V21.9716Z",
    fill: "url(#paint73_linear_51_493)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M43.9412 20.4403V20.7933H42.3086C42.3264 20.6612 42.3799 20.5368 42.4665 20.4149C42.5557 20.2956 42.7314 20.1381 42.9912 19.94C43.2001 19.7775 43.3274 19.6708 43.3758 19.615C43.4395 19.5388 43.4726 19.4575 43.4726 19.3813C43.4726 19.3001 43.4446 19.2315 43.3885 19.1883C43.3325 19.1452 43.2561 19.1198 43.1568 19.1198C43.0574 19.1198 42.9836 19.1452 42.9275 19.1934C42.8689 19.2366 42.8358 19.3179 42.8282 19.4321L42.3621 19.3915C42.3901 19.1833 42.4741 19.036 42.6219 18.9395C42.7645 18.8506 42.9504 18.8049 43.1669 18.8049C43.4064 18.8049 43.5948 18.8582 43.7324 18.9623C43.8725 19.0715 43.9387 19.201 43.9387 19.3585C43.9387 19.4448 43.9183 19.5286 43.8801 19.6099C43.8394 19.6937 43.7808 19.7775 43.6916 19.8638C43.6356 19.9223 43.5363 20.0086 43.3885 20.1153C43.2408 20.2295 43.1466 20.3006 43.1084 20.3387C43.0676 20.3743 43.0396 20.4098 43.0116 20.4403H43.9412Z",
    fill: "url(#paint74_linear_51_493)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M49.7969 34.8976C50.0338 34.8976 50.2121 34.9712 50.3496 35.1109C50.505 35.2785 50.5865 35.5528 50.5865 35.9362C50.5865 36.3197 50.5075 36.5889 50.3445 36.759C50.2121 36.8936 50.0338 36.9622 49.7969 36.9622C49.56 36.9622 49.369 36.8885 49.2238 36.7362C49.0786 36.5889 49.0073 36.3172 49.0073 35.9312C49.0073 35.5452 49.0863 35.2734 49.2493 35.1084C49.3766 34.9738 49.56 34.9001 49.7969 34.9001V34.8976ZM49.7969 35.2226C49.7409 35.2226 49.6925 35.2353 49.6492 35.2658C49.6059 35.2937 49.5728 35.3471 49.5498 35.4233C49.5167 35.5223 49.5014 35.6924 49.5014 35.9337C49.5014 36.1749 49.5142 36.3299 49.5422 36.4187C49.5702 36.5076 49.6059 36.566 49.6492 36.594C49.6925 36.6244 49.7409 36.6397 49.7969 36.6397C49.8529 36.6397 49.8988 36.627 49.9446 36.594C49.9879 36.566 50.021 36.5127 50.044 36.4365C50.0771 36.3375 50.0924 36.1673 50.0924 35.9337C50.0924 35.7001 50.0771 35.5325 50.0491 35.441C50.021 35.3522 49.9854 35.2937 49.9446 35.2658C49.8988 35.2353 49.8504 35.2226 49.7969 35.2226Z",
    fill: "url(#paint75_linear_51_493)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M37.668 21.3494L38.1213 21.3012C38.1366 21.4002 38.1748 21.4764 38.2385 21.5272C38.2971 21.5805 38.3735 21.6085 38.4652 21.6085C38.5569 21.6085 38.6384 21.578 38.7072 21.5145C38.7708 21.451 38.8039 21.3647 38.8039 21.2631C38.8039 21.1615 38.7708 21.0828 38.7122 21.0244C38.6486 20.966 38.5722 20.938 38.4805 20.938C38.4244 20.938 38.3531 20.9482 38.2691 20.966L38.3226 20.646C38.4499 20.646 38.5416 20.6231 38.6104 20.5724C38.674 20.5241 38.7122 20.4606 38.7122 20.3743C38.7122 20.3057 38.6868 20.2498 38.6358 20.2067C38.5874 20.166 38.5212 20.1432 38.4423 20.1432C38.3633 20.1432 38.2945 20.1686 38.2385 20.2143C38.1825 20.2651 38.1494 20.3311 38.1392 20.4225L37.7113 20.359C37.7418 20.2346 37.7851 20.133 37.8488 20.0594C37.9099 19.9832 37.9914 19.9222 38.0959 19.8842C38.2054 19.841 38.3251 19.8181 38.4601 19.8181C38.6868 19.8181 38.8702 19.8816 39.0102 20.0086C39.1223 20.1076 39.1784 20.2244 39.1784 20.3565C39.1784 20.5368 39.0612 20.6841 38.8294 20.7933C38.9695 20.8161 39.0765 20.8746 39.1605 20.9634C39.2446 21.0498 39.2879 21.1564 39.2879 21.2834C39.2879 21.4637 39.2089 21.6212 39.0536 21.7481C38.8956 21.8802 38.7046 21.9411 38.4728 21.9411C38.2589 21.9411 38.0729 21.8878 37.9278 21.7786C37.7851 21.6694 37.6985 21.5247 37.6756 21.3545L37.668 21.3494Z",
    fill: "url(#paint76_linear_51_493)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M34.9526 24.4527V24.0362H33.9644V23.6934L35.0137 22.3805H35.406V23.6883H35.7065V24.0337H35.406V24.4502H34.9526V24.4527ZM34.9526 23.6908V22.9874L34.3999 23.6908H34.9526Z",
    fill: "url(#paint77_linear_51_493)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8913 27.8429L32.3549 27.8023C32.3676 27.8937 32.4084 27.9648 32.472 28.0181C32.5408 28.0664 32.6172 28.0943 32.6987 28.0943C32.7955 28.0943 32.8796 28.0613 32.9458 27.9953C33.012 27.9242 33.0477 27.82 33.0477 27.6829C33.0477 27.5458 33.012 27.4594 32.9458 27.3909C32.8796 27.3274 32.7904 27.2944 32.686 27.2944C32.5485 27.2944 32.4287 27.3452 32.3218 27.4442L31.9448 27.3985L32.1842 26.3116H33.4144V26.6874H32.5383L32.4644 27.043C32.5637 26.9998 32.6733 26.9744 32.7802 26.9744C32.9891 26.9744 33.1597 27.0379 33.3049 27.1699C33.4501 27.2994 33.5214 27.4671 33.5214 27.6728C33.5214 27.848 33.4654 28.0003 33.3482 28.1375C33.1878 28.3229 32.9687 28.4168 32.6885 28.4168C32.4644 28.4168 32.2836 28.3635 32.1384 28.2594C31.9983 28.1553 31.9142 28.0156 31.8862 27.8404L31.8913 27.8429Z",
    fill: "url(#paint78_linear_51_493)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0283 31.2382L33.5749 31.2839C33.5622 31.2026 33.5341 31.1493 33.4908 31.1112C33.4425 31.0706 33.3839 31.0528 33.3075 31.0528C33.2107 31.0528 33.1266 31.0884 33.0579 31.1645C32.9891 31.2357 32.9483 31.3906 32.9305 31.6242C33.0451 31.5074 33.1903 31.4515 33.3635 31.4515C33.5596 31.4515 33.7252 31.515 33.8653 31.6369C34.0003 31.7562 34.0741 31.9188 34.0741 32.1143C34.0741 32.32 33.9977 32.4876 33.8525 32.6146C33.7099 32.739 33.5214 32.8025 33.2922 32.8025C33.0477 32.8025 32.8439 32.7212 32.6885 32.5638C32.5332 32.4013 32.4517 32.1448 32.4517 31.7791C32.4517 31.4134 32.5306 31.1392 32.6987 30.9766C32.8643 30.8116 33.0757 30.7303 33.3406 30.7303C33.5265 30.7303 33.6768 30.7709 33.7965 30.8623C33.9162 30.9487 33.9926 31.0731 34.0283 31.2357V31.2382ZM32.9713 32.0838C32.9713 32.2108 33.0069 32.3099 33.0757 32.3784C33.1495 32.4495 33.226 32.48 33.3177 32.48C33.4017 32.48 33.473 32.4546 33.5341 32.3962C33.5902 32.3429 33.6182 32.2489 33.6182 32.1219C33.6182 31.995 33.5851 31.8934 33.5265 31.835C33.4603 31.7715 33.3864 31.7385 33.2922 31.7385C33.1979 31.7385 33.1292 31.7689 33.0655 31.8299C33.0044 31.8883 32.9738 31.9746 32.9738 32.0864L32.9713 32.0838Z",
    fill: "url(#paint79_linear_51_493)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M34.9194 34.862V34.4887H36.5139V34.7833C36.3814 34.895 36.249 35.0576 36.114 35.2658C35.979 35.474 35.8746 35.7001 35.8033 35.9337C35.7345 36.1673 35.6988 36.3806 35.6988 36.5635H35.2505C35.2582 36.2714 35.3321 35.9769 35.4594 35.6747C35.5919 35.3725 35.7625 35.1033 35.9841 34.8646H34.922L34.9194 34.862Z",
    fill: "url(#paint80_linear_51_493)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M39.9169 37.752C39.7972 37.7063 39.7081 37.6478 39.6571 37.5717C39.6011 37.4955 39.5731 37.4091 39.5731 37.3177C39.5731 37.1653 39.6367 37.0384 39.7641 36.9343C39.8863 36.8378 40.0697 36.787 40.299 36.787C40.5282 36.787 40.7065 36.8378 40.8364 36.9343C40.9637 37.0384 41.03 37.1653 41.03 37.3177C41.03 37.4168 40.9968 37.5031 40.9408 37.5767C40.8822 37.6529 40.7956 37.7113 40.6912 37.752C40.8262 37.7951 40.9281 37.8637 40.9994 37.95C41.0682 38.0415 41.1038 38.143 41.1038 38.2599C41.1038 38.4503 41.03 38.6078 40.8899 38.7271C40.7447 38.8439 40.5588 38.9074 40.3168 38.9074C40.0952 38.9074 39.9144 38.8566 39.7666 38.7576C39.5934 38.6408 39.5068 38.4783 39.5068 38.2751C39.5068 38.1634 39.5399 38.0592 39.6062 37.9653C39.6698 37.8688 39.7717 37.7977 39.9118 37.7494L39.9169 37.752ZM40.0137 37.3507C40.0137 37.4269 40.0417 37.4904 40.0926 37.5361C40.1436 37.5818 40.2124 37.6047 40.3015 37.6047C40.3907 37.6047 40.4594 37.5818 40.5155 37.5361C40.5664 37.4904 40.5893 37.4295 40.5893 37.3507C40.5893 37.272 40.5664 37.2161 40.5155 37.1704C40.462 37.1247 40.3957 37.1019 40.3066 37.1019C40.2175 37.1019 40.1461 37.1247 40.0926 37.1704C40.0417 37.2161 40.0137 37.272 40.0137 37.3507ZM39.9704 38.237C39.9704 38.3487 40.0061 38.4376 40.0697 38.496C40.1334 38.5595 40.2175 38.59 40.3142 38.59C40.411 38.59 40.4925 38.5595 40.5511 38.4986C40.6148 38.4402 40.6479 38.3538 40.6479 38.2421C40.6479 38.143 40.6173 38.0669 40.5511 38.0085C40.4874 37.95 40.4059 37.9196 40.3091 37.9196C40.1945 37.9196 40.1079 37.95 40.0544 38.0186C39.9984 38.0872 39.9704 38.1634 39.9704 38.2395V38.237Z",
    fill: "url(#paint81_linear_51_493)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5857 38.5671L45.034 38.5265C45.0467 38.6052 45.0747 38.6687 45.1206 38.7043C45.1639 38.7449 45.225 38.7627 45.3014 38.7627C45.3982 38.7627 45.4772 38.722 45.5459 38.6459C45.6096 38.5697 45.6555 38.4122 45.6758 38.171C45.5561 38.2878 45.4109 38.3462 45.2352 38.3462C45.0416 38.3462 44.8786 38.2827 44.7411 38.1532C44.601 38.0262 44.5322 37.8586 44.5322 37.6555C44.5322 37.4523 44.6035 37.2745 44.7538 37.145C44.8965 37.013 45.0849 36.952 45.3091 36.952C45.5587 36.952 45.7573 37.0333 45.9178 37.2009C46.0732 37.3609 46.1547 37.6326 46.1547 38.011C46.1547 38.3894 46.0706 38.6738 45.9076 38.8414C45.7421 39.0141 45.5307 39.0979 45.2658 39.0979C45.0773 39.0979 44.9245 39.0547 44.8099 38.9684C44.6927 38.877 44.6163 38.7474 44.5857 38.5697V38.5671ZM45.63 37.6885C45.63 37.5615 45.5994 37.4625 45.5281 37.3914C45.4593 37.3177 45.3804 37.2822 45.2912 37.2822C45.2021 37.2822 45.1333 37.3152 45.0798 37.3736C45.0187 37.432 44.9907 37.5285 44.9907 37.6555C44.9907 37.7926 45.0238 37.8916 45.0849 37.9551C45.1486 38.0186 45.225 38.0491 45.3167 38.0491C45.4084 38.0491 45.4797 38.0186 45.5408 37.9602C45.6045 37.8967 45.6325 37.8129 45.6325 37.691L45.63 37.6885Z",
    fill: "url(#paint82_linear_51_493)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.7
  }, _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M54.9674 32.8177C54.9572 33.9859 54.458 35.2658 53.8365 36.1318C49.3868 31.6496 50.6221 31.2687 54.9674 32.8177Z",
    fill: "#271B1A"
  }))), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M55.8359 32.7289C55.7544 33.8945 55.1049 34.9611 54.3204 35.7889C49.3053 31.0528 50.7902 30.4027 55.8486 32.2057L55.8333 32.7289H55.8359Z",
    fill: "url(#paint83_linear_51_493)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M55.8484 32.2057C55.7669 33.3714 55.1021 34.6208 54.3176 35.4487C49.3025 30.7125 50.7925 30.4027 55.8484 32.2057Z",
    fill: "url(#paint84_radial_51_493)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M54.3176 35.2379C52.1705 33.2063 51.1644 31.9264 51.3198 31.4337C51.3707 31.2763 51.5694 31.1925 51.9107 31.1899C52.606 31.1823 53.8668 31.5074 55.7669 32.1803C55.6752 33.1885 55.1149 34.3719 54.3176 35.2379Z",
    fill: "url(#paint85_radial_51_493)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_51_493",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(73.8355 19.0512) scale(13.7463 13.7056)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2A23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#AD1714"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#B21714"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#C21915"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#DD1D16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF2219"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_51_493",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(64.5287 16.0775) scale(17.3733 17.3218)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2A23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#F22720"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#D4201B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#BE1B17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#B11814"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#AD1714"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#B01714"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#B91916"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#C91D19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#E0221D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF2A23"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_51_493",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(58.7953 19.1274) scale(21.3364 21.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2A23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#E4231E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#CC1E19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#BA1A16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#B01714"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#AD1714"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF2A23"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_51_493",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(70.1704 19.9934) scale(7.70221 7.6794)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#FAC2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#F03737"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED0000"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_51_493",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(71.324 16.8774) scale(6.97886 6.95819)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#FAC2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#F03737"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED0000"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_51_493",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(42.9922 7.099) rotate(0.229319) scale(13.2578 1.83026)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BDAEBC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#C1939E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#CD5052"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#D9110A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#740905"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_51_493",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(42.8375 11.3185) rotate(0.229319) scale(14.1521 0.962058)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BDAEBC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#7A707A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#454045"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#1F1D1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#080708"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_51_493",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(73.1513 12.3216) rotate(25.4939) scale(8.31584 4.69946)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BDAEBC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#C1939E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#CD5052"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#D9110A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#740905"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_51_493",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(73.9051 13.0827) rotate(21.0829) scale(2.93434 1.90433)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BDAEBC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#A497A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#796F78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#534D53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#353135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#1D1B1D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#0D0C0D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#030203"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_51_493",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(11.8816 0.126976) rotate(-180) scale(13.7463 13.7056)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2A23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#AD1714"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#B21714"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#C21915"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#DD1D16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF2219"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_51_493",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(21.1886 0.126974) rotate(180) scale(17.3733 17.3218)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2A23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#F22720"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#D4201B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#BE1B17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#B11814"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#AD1714"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#B01714"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#B91916"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#C91D19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#E0221D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF2A23"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_51_493",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(26.922 0.126973) rotate(180) scale(21.3364 21.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2A23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#E4231E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#CC1E19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#BA1A16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#B01714"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#AD1714"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF2A23"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_51_493",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(15.547 19.9934) scale(7.70221 7.6794)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#FAC2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#F03737"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED0000"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial_51_493",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(14.3931 16.8774) scale(6.97376 6.95311)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#FAC2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#F03737"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED0000"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint14_radial_51_493",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(13.4257 12.3839) rotate(154.506) scale(8.31584 4.69946)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BDAEBC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#C1939E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#CD5052"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#D9110A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#740905"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint15_radial_51_493",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(11.0098 13.8799) rotate(158.917) scale(2.93435 1.90433)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BDAEBC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#A497A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#796F78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#534D53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#353135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#1D1B1D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#0D0C0D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#030203"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_51_493",
    x1: -7.07673,
    y1: 17.1641,
    x2: -6.24776,
    y2: 18.7288,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B20000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#FF6465"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#AE1818"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#950000"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint17_radial_51_493",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(29.1007 9.29578) scale(3.68483 2.06658)"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#333333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#696969"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#979797"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#BCBCBC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint18_radial_51_493",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(53.8686 9.38126) scale(3.68483 2.06658)"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#333333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#696969"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#979797"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#BCBCBC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_51_493",
    x1: 15.8882,
    y1: 57.273,
    x2: 69.8291,
    y2: 57.273,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED1611"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#F5888D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#C90D09"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#C10C08"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#C2100D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#C81E1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#D23433"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#DF5355"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#EF7B7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#F5888D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED1A14"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint20_radial_51_493",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(42.7415 39.7963) scale(32.3676 32.2718)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#FCFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#F6EBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#EBD4D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#DCB3B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#C98A88"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B96765"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint21_radial_51_493",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(19.658 38.4495) rotate(-79.5397) scale(12.6648 1.02419)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BEAFBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#B9ABB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#786E77"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#443F44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#1F1C1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#080708"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint22_radial_51_493",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(63.2693 34.9615) rotate(-99.267) scale(12.6661 1.43407)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BEAFBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#B9ABB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#786E77"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#443F44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#1F1C1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#080708"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint23_radial_51_493",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(43.1191 32.7525) scale(16.3018 12.9453)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.49
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#0F0E0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#393539"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#7C727B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#BEAFBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#A79AA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#756B74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#4B454A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#2A262A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#121112"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#040404"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint24_radial_51_493",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(42.5979 52.4393) scale(24.2436 1.51074)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BEAFBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#5B535A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#191719"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint25_radial_51_493",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(42.7847 31.4195) scale(20.6269 4.55273)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BEAFBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#5B535A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#191719"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint26_radial_51_493",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(33.7035 44.4656) rotate(-62.6707) scale(6.96837 12.5646)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BDAEBC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#C1939E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#CD5052"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#D9110A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#740905"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint27_radial_51_493",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(52.9368 41.6601) rotate(-117.329) scale(6.96837 12.5646)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BDAEBC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#C1939E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#CD5052"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#D9110A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#740905"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint28_radial_51_493",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(43.4229 51.2402) rotate(-96.7297) scale(5.63768 24.7361)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BDAEBC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#C1939E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#CD5052"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#D9110A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#740905"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint29_radial_51_493",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(24.0805 29.2417) rotate(-66.1773) scale(9.9294 7.88663)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0DFE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#ECC3CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#E47C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#D9110A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#740905"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint30_radial_51_493",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(60.9716 29.2181) rotate(-113.823) scale(9.9294 7.88663)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0DFE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#ECC3CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#E47C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#D9110A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#740905"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint31_radial_51_493",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(42.7285 17.591) scale(19.5535 19.4956)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EE281B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#E72419"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#D21912"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#C6130F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#C2110E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#CA130E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#E31A10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#ED1D11"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint32_radial_51_493",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(42.5472 14.2063) scale(8.09924 0.489409)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BEAFBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#5B535A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#191719"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint33_radial_51_493",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(30.3972 9.87592) rotate(-2.32311) scale(1.61027 0.391591)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BEAFBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#5B535A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#191719"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint34_radial_51_493",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(55.3845 9.86042) rotate(-177.677) scale(1.61027 0.391591)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BEAFBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#5B535A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#191719"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_51_493",
    x1: 29.7822,
    y1: 29.3209,
    x2: 55.9351,
    y2: 29.3209,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#271B1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#271B1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#271B1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#271B1A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint36_radial_51_493",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(41.6539 22.119) scale(19.4033 21.8607)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#FBFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#EFECEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#DCD5D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#C2B5B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#AC9A9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#291D1C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint37_radial_51_493",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(41.6539 22.119) scale(19.4033 21.8607)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#715E5E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint38_radial_51_493",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(38.4113 20.9081) scale(1.89753 2.13786)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#271B1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#271B1A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint39_radial_51_493",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(34.8407 23.2784) scale(1.92555 2.16943)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#271B1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#271B1A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint40_radial_51_493",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(32.8464 27.2384) scale(1.95357 2.201)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#271B1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#271B1A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint41_radial_51_493",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(33.1977 31.6318) scale(1.97904 2.22969)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#271B1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#271B1A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint42_radial_51_493",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(35.7832 35.7296) scale(2.00706 2.26126)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#271B1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#271B1A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint43_radial_51_493",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(40.3294 37.724) scale(2.03508 2.29282)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#271B1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#271B1A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint44_radial_51_493",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(45.2603 37.7211) scale(2.06309 2.32439)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#271B1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#271B1A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint45_radial_51_493",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(49.7713 35.8501) scale(2.09111 2.35595)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#271B1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#271B1A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint46_radial_51_493",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(43.0902 20.2595) scale(2.21591 2.49657)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#271B1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#271B1A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_51_493",
    x1: 29.7822,
    y1: 34.8976,
    x2: 55.9351,
    y2: 34.8976,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#271B1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#A39192"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#271B1A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint48_radial_51_493",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(42.9098 25.9471) scale(8.58858 9.67635)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#271B1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#271B1A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint49_radial_51_493",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(43.0011 28.151) scale(6.23767 7.02769)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#271B1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#271B1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#271B1A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_51_493",
    x1: 43.1826,
    y1: 20.9533,
    x2: 43.1826,
    y2: 32.0419,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#271B1A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_51_493",
    x1: 36.0786,
    y1: 31.1011,
    x2: 49.9243,
    y2: 31.1011,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#271B1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#271B1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#2E2322"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#443938"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#665E5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#979191"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#D4D1D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#271B1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#271B1A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint52_radial_51_493",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(47.6977 21.3988) scale(2.20063 2.47935)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#271B1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#271B1A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_51_493",
    x1: 45.6729,
    y1: 19.6861,
    x2: 49.7659,
    y2: 19.6861,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#271B1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#271B1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#2E2322"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#443938"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#665E5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#979191"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#D4D1D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#271B1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#271B1A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_51_493",
    x1: 41.0551,
    y1: 18.5535,
    x2: 45.2144,
    y2: 18.5535,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#271B1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#271B1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#2E2322"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#443938"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#665E5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#979191"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#D4D1D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#271B1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#271B1A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_51_493",
    x1: 36.3458,
    y1: 19.5109,
    x2: 40.5662,
    y2: 19.5109,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#271B1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#271B1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#2E2322"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#443938"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#665E5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#979191"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#D4D1D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#271B1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#271B1A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_51_493",
    x1: 32.6985,
    y1: 22.1468,
    x2: 36.9801,
    y2: 22.1468,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#271B1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#271B1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#2E2322"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#443938"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#665E5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#979191"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#D4D1D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#271B1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#271B1A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_51_493",
    x1: 30.6738,
    y1: 26.0907,
    x2: 35.0165,
    y2: 26.0907,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#271B1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#271B1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#2E2322"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#443938"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#665E5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#979191"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#D4D1D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#271B1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#271B1A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_51_493",
    x1: 30.9946,
    y1: 30.423,
    x2: 35.3984,
    y2: 30.423,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#271B1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#271B1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#2E2322"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#443938"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#665E5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#979191"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#D4D1D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#271B1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#271B1A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_51_493",
    x1: 33.5111,
    y1: 34.25,
    x2: 37.9786,
    y2: 34.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#271B1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#271B1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#2E2322"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#443938"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#665E5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#979191"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#D4D1D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#271B1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#271B1A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_51_493",
    x1: 38.0267,
    y1: 36.4416,
    x2: 42.5554,
    y2: 36.4416,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#271B1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#271B1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#2E2322"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#443938"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#665E5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#979191"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#D4D1D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#271B1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#271B1A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear_51_493",
    x1: 42.9654,
    y1: 36.594,
    x2: 47.5552,
    y2: 36.594,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#271B1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#271B1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#2E2322"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#443938"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#665E5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#979191"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#D4D1D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#271B1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#271B1A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear_51_493",
    x1: 47.4433,
    y1: 34.4989,
    x2: 52.0967,
    y2: 34.4989,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#271B1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#271B1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#2E2322"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#443938"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#665E5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#979191"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#D4D1D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#271B1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#271B1A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear_51_493",
    x1: 45.673,
    y1: 19.5718,
    x2: 49.766,
    y2: 19.5718,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#271B1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#2E2322"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#443938"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#665E5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#979191"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#D4D1D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#271B1A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint64_linear_51_493",
    x1: 41.0552,
    y1: 18.4417,
    x2: 45.2145,
    y2: 18.4417,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#271B1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#2E2322"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#443938"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#665E5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#979191"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#D4D1D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#271B1A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint65_linear_51_493",
    x1: 36.3457,
    y1: 19.3966,
    x2: 40.5661,
    y2: 19.3966,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#271B1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#2E2322"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#443938"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#665E5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#979191"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#D4D1D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#271B1A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint66_linear_51_493",
    x1: 32.6986,
    y1: 22.0326,
    x2: 36.9802,
    y2: 22.0326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#271B1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#2E2322"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#443938"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#665E5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#979191"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#D4D1D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#271B1A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint67_linear_51_493",
    x1: 30.6738,
    y1: 25.9789,
    x2: 35.0165,
    y2: 25.9789,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#271B1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#2E2322"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#443938"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#665E5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#979191"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#D4D1D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#271B1A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint68_linear_51_493",
    x1: 30.9946,
    y1: 30.3113,
    x2: 35.3984,
    y2: 30.3113,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#271B1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#2E2322"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#443938"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#665E5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#979191"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#D4D1D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#271B1A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint69_linear_51_493",
    x1: 33.5112,
    y1: 34.1357,
    x2: 37.9787,
    y2: 34.1357,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#271B1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#2E2322"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#443938"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#665E5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#979191"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#D4D1D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#271B1A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint70_linear_51_493",
    x1: 38.0269,
    y1: 36.3273,
    x2: 42.5555,
    y2: 36.3273,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#271B1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#2E2322"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#443938"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#665E5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#979191"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#D4D1D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#271B1A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint71_linear_51_493",
    x1: 42.9654,
    y1: 36.4822,
    x2: 47.5552,
    y2: 36.4822,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#271B1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#2E2322"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#443938"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#665E5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#979191"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#D4D1D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#271B1A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint72_linear_51_493",
    x1: 47.4434,
    y1: 34.3846,
    x2: 52.0968,
    y2: 34.3846,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#271B1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#2E2322"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#443938"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#665E5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#979191"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#D4D1D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#271B1A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint73_linear_51_493",
    x1: 47.5299,
    y1: 14.6808,
    x2: 47.5299,
    y2: 41.871,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint74_linear_51_493",
    x1: 43.1236,
    y1: 14.6808,
    x2: 43.1236,
    y2: 41.871,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint75_linear_51_493",
    x1: 49.7969,
    y1: 14.6757,
    x2: 49.7969,
    y2: 41.8786,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint76_linear_51_493",
    x1: 38.4754,
    y1: 14.6808,
    x2: 38.4754,
    y2: 41.871,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint77_linear_51_493",
    x1: 34.8329,
    y1: 14.6757,
    x2: 34.8329,
    y2: 41.8837,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint78_linear_51_493",
    x1: 32.7089,
    y1: 14.6808,
    x2: 32.7089,
    y2: 41.8761,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint79_linear_51_493",
    x1: 33.2591,
    y1: 14.6757,
    x2: 33.2591,
    y2: 41.8761,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint80_linear_51_493",
    x1: 35.7167,
    y1: 14.6757,
    x2: 35.7167,
    y2: 41.8786,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint81_linear_51_493",
    x1: 40.3091,
    y1: 14.6782,
    x2: 40.3091,
    y2: 41.8761,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint82_linear_51_493",
    x1: 45.3447,
    y1: 14.6756,
    x2: 45.3447,
    y2: 41.8761,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint83_linear_51_493",
    x1: 53.8849,
    y1: 33.5133,
    x2: 55.2822,
    y2: 34.0746,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#CEC0C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#C1B1B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#B8A7A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#271B1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#271B1A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint84_radial_51_493",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(52.2142 31.5819) rotate(-0.598223) scale(3.78488 4.26425)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#271B1A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint85_radial_51_493",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(52.2624 31.5613) rotate(-0.598223) scale(3.62442 4.08346)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#271B1A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGamificationPhone);
export default __webpack_public_path__ + "static/media/gamification-phone.b90ba0c1dd70e312e0e48e50ef29a941.svg";
export { ForwardRef as ReactComponent };